module.exports = __webpack_public_path__ + "media/images/icons/inventory-70648089a84b103ba5439bbfaae1ff03.svg";